module.exports = __webpack_public_path__ + "img/image7.f00dd4a9.webp";